import { Injectable } from '@angular/core';
import LogRocket from 'logrocket';

/**
 * Wrapper for LogRocket, to allow stubbing it in tests.
 */
@Injectable({ providedIn: 'root' })
export class LogRocketService {
  init(...params: Parameters<typeof LogRocket.init>) {
    LogRocket.init(...params);
  }

  // No easy way to make the typing here right
  // https://github.com/microsoft/TypeScript/issues/32164
  identify(uid: string, traits?: any) {
    LogRocket.identify(uid, traits);
  }

  getSessionURL(...params: Parameters<typeof LogRocket.getSessionURL>) {
    LogRocket.getSessionURL(...params);
  }

  track(...params: Parameters<typeof LogRocket.track>) {
    LogRocket.track(...params);
  }
}
